import React from "react";
import Page from "../models/Page";
import EditableText from "./EditableText";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { RDiv } from "./renderPrimitives/RDiv";
import { RText } from "./renderPrimitives/RText";
import { RBr } from "./renderPrimitives/RBr";
import { RImg } from "./renderPrimitives/RImg";

export function calcPageNumberOfHeader(page: Page, sheetNumber?: number, print?: PagePrintInfo): string {
  var pagenumber = "-/-";

  if (print) {
    if (sheetNumber) {
      sheetNumber = sheetNumber + print.firstSheetNumber - 1;
    } else {
      sheetNumber = print.firstSheetNumber;
    }

    pagenumber = `${sheetNumber}/${print.totalNumberOfSheets}`;
  } else if (sheetNumber) {
    pagenumber = `${sheetNumber}/${page.numberOfSheets}`;
  }

  return pagenumber;
}

// Interne Komponente für kleine Header (showSmall = true)
function HeaderSmall(props: {
  page: Page;
  sheetNumber?: number;
  print?: PagePrintInfo;
  adjustActive?: boolean;
  pagenumber: string;
}) {
  const { page, pagenumber } = props;

  const headerSize = { width: 7, height: 1 };
  const borderWidthInPx = 2;
  const showSmallStyle = {
    padding: "0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const horizontalPadding = "15px";


  return (
    <RDiv
      id="pageHeader"
      style={{
        position: "absolute",
        right: `${borderWidthInPx}px`,
        bottom: `${borderWidthInPx}px`,
        display: "flex",
        flexDirection: "row",
        height: `${headerSize.height}cm`,
        pointerEvents: "auto",
        borderTopWidth: `${borderWidthInPx}px`,
        borderTopStyle: "solid",
        borderTopColor: "black",
        borderLeftWidth: `${borderWidthInPx}px`,
        borderLeftStyle: "solid",
        borderLeftColor: "black",
        backgroundColor: "white"
      }}
    >


      <RDiv style={{
        display: "flex", flexDirection: "row", alignItems: "center",
        height: `${headerSize.height}cm`,
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding
      }}>
        <RText>{page.documentTag}</RText>
      </RDiv>


      <RDiv style={{
        display: "flex", flexDirection: "row", alignItems: "center",
        height: `${headerSize.height}cm`,
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding,
        borderLeftWidth: `${borderWidthInPx}px`,
        borderLeftStyle: "solid",
        borderLeftColor: "black",
      }}>
        <RText>{page.documentTitle}</RText>
      </RDiv>


      <RDiv
        style={{
          position: "relative",
          height: `${headerSize.height}cm`,
          paddingLeft: horizontalPadding,
          paddingRight: horizontalPadding,

          borderLeftWidth: `${borderWidthInPx}px`,
          borderLeftStyle: "solid",
          borderLeftColor: "black",
          ...showSmallStyle,
        }}
      >
        <RText>{pagenumber}</RText>
      </RDiv>
    </RDiv>
  );
}

// Interne Komponente für große Header (showSmall = false)
function HeaderBig(props: {
  page: Page;
  sheetNumber?: number;
  print?: PagePrintInfo;
  adjustActive?: boolean;
  pagenumber: string;
}) {
  const { page, pagenumber, adjustActive, print } = props;

  const headerSize = { width: 8, height: 3 };
  const borderWidthInPx = 2;

  function setImgToTransparent(ev: any): React.ReactEventHandler<HTMLImageElement> | undefined {
    let imgElement = document.getElementById(`companyLogo_${page.id}`);
    if (imgElement?.style) {
      imgElement.style.opacity = "0";
    }
    return undefined;
  }

  const horizontalPadding = "15px";



  return (
    <RDiv
      id="pageHeader"
      style={{
        position: "absolute",
        right: `${borderWidthInPx}px`,
        bottom: `${borderWidthInPx}px`,
        display: "flex",
        flexDirection: "row",
        height: `${headerSize.height}cm`,
        pointerEvents: "auto",
        borderTopWidth: `${borderWidthInPx}px`,
        borderTopStyle: "solid",
        borderTopColor: "black",
        borderLeftWidth: `${borderWidthInPx}px`,
        borderLeftStyle: "solid",
        borderLeftColor: "black",
        backgroundColor: "white"
      }}
    >
      <RDiv
        style={{
          position: "relative",
          width: "3cm",
          height: "3cm",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <RImg
          id={`companyLogo_${page.id}`}
          style={{
            height: "calc(100% - 1cm)",
            width: "calc(100% - 1cm)",
            marginTop: "0.25cm",
            objectFit: "contain",
          }}
          src={state.settings.companyLogo}
          onError={(ev) => setImgToTransparent(ev)}
        />
        <RDiv><RText>{state.settings.companyName}</RText></RDiv>
      </RDiv>

      <RDiv
        style={{
          position: "relative",
          width: "3cm",
          height: `${headerSize.height}cm`,
          paddingLeft: "0.25cm",
          textAlign: "left",
          lineHeight: "1em",
        }}
      >
        <RText style={{ fontSize: "0.75rem" }}>
          {state.translate("PageHeaderNarrow.issueDate", "Ausgabedatum")}
        </RText>
        <RBr />
        <RText>{page.documentDate}</RText>
      </RDiv>

      <RDiv
        style={{
          width: "5cm",
          minWidth: "5cm",
          height: `${headerSize.height}cm`,
          paddingHorizontal: "0.25cm",
          backgroundColor: "white",
          borderLeftWidth: `${borderWidthInPx}px`,
          borderLeftStyle: "solid",
          borderLeftColor: "black",
          marginLeft: `${borderWidthInPx}px`,
        }}
      >
        <RText style={{ fontSize: "0.75rem" }}>
          {page.documentType.name}
        </RText>
        <RBr />


        <RDiv style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <RDiv style={{
            display: "flex", flexDirection: "row", alignItems: "center",
            height: `${headerSize.height}cm`,
            paddingLeft: horizontalPadding,
            paddingRight: horizontalPadding
          }}>
            <RText>{page.documentTag}</RText>
          </RDiv>

          <RDiv style={{
            display: "flex", flexDirection: "row", alignItems: "center",
            height: `${headerSize.height}cm`,
            paddingLeft: horizontalPadding,
            paddingRight: horizontalPadding,
            borderLeftWidth: `${borderWidthInPx}px`,
            borderLeftStyle: "solid",
            borderLeftColor: "black",
          }}>
            <RText>{page.documentTitle}</RText>
          </RDiv>
        </RDiv>


      </RDiv>


      <RDiv
        style={{
          width: "5cm",
          height: `${headerSize.height}cm`,
          paddingLeft: "0.25cm",
          textAlign: "left",
          lineHeight: "1em",
        }}
      >
        <RText style={{ fontSize: "0.75rem" }}>
          {state.translate("coverPage.projectName", "Project Name")}
        </RText>
        <RBr />
        <RText>{state.projectMetadata.name}</RText>
      </RDiv>

      <RDiv
        style={{
          position: "relative",
          height: `${headerSize.height}cm`,
          paddingHorizontal: "0.25cm",
          backgroundColor: "white",
          borderLeftWidth: `${borderWidthInPx}px`,
          borderLeftStyle: "solid",
          borderLeftColor: "black",
        }}
      >
        <RText style={{ fontSize: "0.75rem" }}>
          {state.translate("PageHeaderNarrow.page", "Seite")}
        </RText>
        <RBr />
        <RText>{pagenumber}</RText>
      </RDiv>
    </RDiv>
  );
}

export default function PageHeader(props: {
  page: Page;
  sheetNumber?: number;
  print?: PagePrintInfo;
  adjustActive?: boolean;
}) {
  const { page, sheetNumber, print, adjustActive } = props;

  useOnChangeWatcher(page);

  // for update projectName
  useOnChangeWatcher(state.projectMetadata, (changedProperty) => {
    if (changedProperty == "name") {
      return true;
    } else {
      return false;
    }
  });

  const showSmall = state.settings.showSmallHeader;
  const pagenumber = calcPageNumberOfHeader(page, sheetNumber, print);

  // Einfache Weiterleitung an die entsprechende Teilkomponente
  if (showSmall) {
    return <HeaderSmall
      page={page}
      sheetNumber={sheetNumber}
      print={print}
      adjustActive={adjustActive}
      pagenumber={pagenumber}
    />;
  } else {
    return <HeaderBig
      page={page}
      sheetNumber={sheetNumber}
      print={print}
      adjustActive={adjustActive}
      pagenumber={pagenumber}
    />;
  }
}
